
const ChartHelper = {

    getHash( hash )
    {
        if( !hash )
        {
            return 'n/a';
        }

        return `${hash.substr( 0, 11 )}...`;
    }
};

export default ChartHelper;



// WEBPACK FOOTER //
// ./src/lib/components/Charts/chart-helper.js